import script from "./ColumnSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnSettings.vue?vue&type=script&setup=true&lang=js"

import "./ColumnSettings.vue?vue&type=style&index=0&id=74301d19&lang=scss&scoped=true"

import exportComponent from "/root/workspace/public_sso_ZgiA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74301d19"]])

export default __exports__